<template>
  <div>
    <b-table hover
        responsive="sm" 
        class="registro registro-presupuestos"
        :busy="tableBusy"
        :items="presupuestos" 
        :fields="vistaPresupuestos" 
        @row-clicked="consultar">
      <div slot="table-busy" class="text-center">
        <b-spinner class="table-spinner" label="Spinning" />
      </div>              
      <template v-slot:cell(fechaRegistro)="data">
        {{ data.item.fechaRegistro | fecha }}
      </template>
      <template v-slot:cell(fechaUltimaEdicion)="data">
        {{ data.item.fechaUltimaEdicion | fecha }}
      </template>
      <template v-slot:cell(fechaConfirmacion)="data">
        {{ data.item.fechaConfirmacion | fecha }}
      </template>
      <template v-slot:cell(fechaCancelacion)="data">
        {{ data.item.fechaCancelacion | fecha }}
      </template>
      <template v-slot:cell(fechaCierreEstimado)="data">
        {{ data.item.fechaCierreEstimado | fecha }}
      </template>
      <template v-slot:cell(fechaCierre)="data">
        {{ data.item.fechaCierre | fecha }}
      </template>
      <template v-slot:cell(importeNetoPresupuestado)="data">
        {{ data.item.importeNetoPresupuestado | moneda(data.item.moneda) }}
      </template>
      <template v-slot:cell(pjeCertificado)="data">
        {{ data.item.pjeCertificado | porcentaje }}
      </template>
      <template v-slot:cell(pjeFacturado)="data">
        {{ data.item.pjeFacturado | porcentaje }}
      </template>
      <template v-slot:cell(saldoFacturar)="data">
        {{ data.item.saldoFacturar | moneda(data.item.moneda) }}
      </template>

      <template v-slot:cell(opciones)="data" v-if= "!readOnly && contextMenuVisible">
        <b-dropdown variant="link" 
            toggle-class="text-decoration-none" 
            no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v"></i>
          </template>

          <b-dropdown-item 
              @click.stop="editarItem(data.item)"
              v-if="opcionEditar & !data.item.cerrado">
            <i class="fa fa-edit"></i>Editar Presupuesto</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="editarProduccionItem(data.item)"
              v-if="opcionEditarProduccion">
            <i class="fa fa-edit"></i>Editar Información de Producción</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="consultarProduccionItem(data.item)"
              v-if="opcionConsultarProduccion">
            <i class="fa fa-info"></i>Consultar Información de Producción</b-dropdown-item>

          <!-- <b-dropdown-item 
              @click.stop="consultarItemConsolidado(data.item)"
              v-if="!data.item.adicional">
            <i class="fa fa-info"></i>Consultar Presupuesto Consolidado</b-dropdown-item> -->

          <b-dropdown-item 
              @click.stop="confirmarPresupuesto(data.item)"
              v-if="opcionConfirmar">
            <i class="fa fa-check-square"></i>Confirmar Presupuesto</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="anularConfirmacionPresupuesto(data.item)"
              v-if="opcionAnularConfirmacion">
            <i class="fa fa-remove"></i>Anular Confirmación del Presupuesto</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="cerrarPresupuesto(data.item)"
              v-if="opcionCerrarPresupuesto & !data.item.cerrado">
            <i class="fa fa-lock"></i>Cerrar Presupuesto</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="abrirPresupuesto(data.item)"
              v-if="opcionAbrirPresupuesto & data.item.cerrado">
            <i class="fa fa-unlock"></i>Abrir Presupuesto</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="actualizarCierreEstimadoPresupuesto(data.item)"
              v-if="opcionActualizarCierreEstimado">
            <i class="fa fa-calendar"></i>Actualizar Cierre Estimado</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="duplicar(data.item)"
              v-if="opcionDuplicarPresupuesto">
            <i class="fa fa-copy"></i>Duplicar Presupuesto</b-dropdown-item>

          <b-dropdown-item @click.stop="autorizar(data.item)" 
              v-if="opcionAutorizarPresupuesto & !data.item.autorizado & !data.item.cerrado">
            <i class="fa fa-check"></i>Autorizar Presupuesto</b-dropdown-item>

          <b-dropdown-item @click.stop="cancelarAutorizacion(data.item)" 
              v-if="opcionAutorizarPresupuesto & data.item.autorizado & !data.item.cerrado">
            <i class="fa fa-remove"></i>Cancelar Autorizacion</b-dropdown-item>

          <!-- <b-dropdown-item 
              @click.stop="agregarPresupuestoAdicional(data.item)"
              v-if="opcionAgregarPresupuestoAdicional & !data.item.adicional">
            <i class="fa fa-plus"></i>Agregar Adicional</b-dropdown-item> -->

          <b-dropdown-item 
              @click.stop="cancelar(data.item)"
              v-if="opcionCancelarPresupuesto">
            <i class="fa fa-remove"></i>Cancelar Presupuesto</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="restablecer(data.item)"
              v-if="opcionRestablecerPresupuesto">
              <i class="fa fa-undo"></i>Restablecer Presupuesto</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="borrarItem(data.item)"
              v-if="opcionBorrar">
            <i class="fa fa-remove"></i>Borrar Presupuesto</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="addBrief(data.item)"
              v-if="opcionAddBrief && !data.item.tieneBriefs">
            <i class="fa fa-plus"></i>Generar Brief de Diseño</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="consultarBrief(data.item)"
              v-if="opcionConsultarBrief && data.item.tieneBriefs">
            <i class="fa fa-folder"></i>Consultar Brief de Diseño</b-dropdown-item>

          <!-- <b-dropdown-item @click.stop="usuariosItem(data.item)">
            <i class="fa fa-user"></i>Asignar Usuarios</b-dropdown-item> -->

          <b-dropdown-item 
              @click.stop="consultarImagenes(data.item)"
              v-if="opcionConsultarImagenesRemitos">
            <i class="fa fa-image"></i>Consultar Imagenes de Remitos</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="emitirPresupuestoCliente(data.item)"
              v-if="opcionEmitirPresupuestoCliente">
            <i class="fa fa-file-pdf-o"></i>Emitir Presupuesto al Cliente</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="emitirPresupuestoInterno(data.item)"
              v-if="opcionEmitirPresupuestoInterno">
            <i class="fa fa-file-pdf-o"></i>Emitir Presupuesto Interno (Producción)</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="emitirCertificadoServicio(data.item)"
              v-if="opcionEmitirCertificadoServicio">
            <i class="fa fa-edit"></i>Emitir Certificado de Servicio</b-dropdown-item>

          <b-dropdown-item 
              @click.stop="emitirFacturaProforma(data.item)"
              v-if="opcionEmitirFacturaProforma">
            <i class="fa fa-edit"></i>Emitir Factura Proforma</b-dropdown-item>


          <b-dropdown-item 
              @click.stop="exportarExcel(data.item)"
              v-if="opcionExportarExcel">
            <i class="fa fa-file-excel-o"></i>Exportar Presupuesto</b-dropdown-item>
          </b-dropdown>
        </template>

        <template v-slot:cell(opcionesProduccion)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <!-- <b-dropdown-item @click.stop="editarItem(data.item)">
              <i class="fa fa-edit"></i>Editar Presupuesto</b-dropdown-item> -->
            <b-dropdown-item 
                @click.stop="editarProduccionItem(data.item)">
              <i class="fa fa-edit"></i>Editar Información de Producción</b-dropdown-item>

            <b-dropdown-item 
                @click.stop="emitirPresupuestoInterno(data.item)"
                v-if="opcionEmitirPresupuestoInterno">
              <i class="fa fa-file-pdf-o"></i>Emitir Presupuesto Interno (Producción)</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <nav v-if="opcionPagination">
        <b-pagination size="sm" 
          :total-rows="totalRegistros" 
          :per-page="registrosPorPagina" 
          v-model="paginaActualTabla" prev-text="Prev." next-text="Prox."/>
      </nav>
  </div>
</template>

<script>

export default {
  name: 'PresupuestosInternos',
  props: {
    estado: {
      type: String,
      default: ''
    },
    presupuestos: {
      type: Array,
      default: null
    },
    tableBusy: {
      type: Boolean,
      default: false
    },
    vistaPresupuestos: {
      type: Array,
      default: null
    },
    paginaActual: {
      type: Number,
      default: 0
    },
    registrosPorPagina: {
      type: Number,
      default: 0
    },
    totalRegistros: {
      type: Number,
      default: 0
    },
    totalPaginas: {
      type: Number,
      default: 0
    },
    opcionEditar: {
      type: Boolean,
      default: false
    },
    opcionEditarProduccion: {
      type: Boolean,
      default: false
    },
    opcionConsultarProduccion: {
      type: Boolean,
      default: false
    },
    opcionBorrar: {
      type: Boolean,
      default: false
    },
    opcionConfirmar: {
      type: Boolean,
      default: false
    },
    opcionAnularConfirmacion: {
      type: Boolean,
      default: false
    },
    opcionEmitirPresupuestoCliente: {
      type: Boolean,
      default: false
    },
    opcionConsultarImagenesRemitos: {
      type: Boolean,
      default: false
    },
    opcionEmitirPresupuestoInterno: {
      type: Boolean,
      default: false
    },
    opcionEmitirCertificadoServicio: {
      type: Boolean,
      default: false
    },
    opcionDuplicarPresupuesto: {
      type: Boolean,
      default: false
    },
    opcionCancelarPresupuesto: {
      type: Boolean,
      default: false
    },
    opcionAutorizarPresupuesto: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    opcionPagination: {
      type: Boolean,
      default: true
    },
    opcionExportarExcel: {
      type: Boolean,
      default: false
    },
    opcionAbrirPresupuesto: {
      type: Boolean,
      default: false
    },
    opcionCerrarPresupuesto: {
      type: Boolean,
      default: false
    },
    opcionAgregarPresupuestoAdicional: {
      type: Boolean,
      default: false
    },
    opcionEmitirFacturaProforma: {
      type: Boolean,
      default: false
    },
    opcionAddBrief: {
      type: Boolean,
      default: false
    },
    opcionConsultarBrief: {
      type: Boolean,
      default: false
    },
    opcionActualizarCierreEstimado: {
      type: Boolean,
      default: false
    },
    opcionRestablecerPresupuesto: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      paginaActualTabla: 0,
    }
  },
  created() {
    this.paginaActualTabla = this.paginaActual;
  },
  computed: {
    contextMenuVisible() {
      if (this.opcionEditar 
        || this.opcionEditarProduccion
        || this.opcionConsultarProduccion
        || this.opcionConfirmar
        || this.opcionAnularConfirmacion
        || this.opcionCerrarPresupuesto
        || this.opcionAbrirPresupuesto
        || this.opcionActualizarCierreEstimado
        || this.opcionDuplicarPresupuesto
        || this.opcionAutorizarPresupuesto
        || this.opcionAgregarPresupuestoAdicional
        || this.opcionCancelarPresupuesto
        || this.opcionRestablecerPresupuesto
        || this.opcionBorrar
        || this.opcionAddBrief
        || this.opcionConsultarBrief
        || this.opcionConsultarImagenesRemitos
        || this.opcionEmitirPresupuestoCliente
        || this.opcionEmitirPresupuestoInterno
        || this.opcionEmitirFacturaProforma
        || this.opcionEmitirCertificadoServicio
        || this.opcionExportarExcel) {
          return true;
      }

      return false;
    } 
  },
  methods: {
    consultar (item) {
      this.$emit('consultarPresupuesto', item);
    },
    consultarItemConsolidado (item) {
      this.$emit('consultarPresupuestoConsolidado', item);
    },
    editarItem (item) {
      this.$emit('editarPresupuesto', item);
    },
    editarProduccionItem (item) {
      this.$emit('editarProduccion', item);
    },
    consultarProduccionItem (item) {
      this.$emit('consultarProduccion', item);
    },
    borrarItem (item) {
      let params = {
        estado: this.estado,
        item
      }
      this.$emit('borrarPresupuesto', params);
    },
    addBrief (item) {
      let params = {
        estado: this.estado,
        item
      }

      this.$emit('addBrief', params);
    },
    consultarBrief (item) {
      this.$emit('consultarBrief', item);
    },
    // usuariosItem (item) {
    //   this.$emit('consultarUsuarios', item);
    // },
    confirmarPresupuesto (item) {
      let params = {
        estado: this.estado,
        item
      }
      this.$emit('confirmarPresupuesto', params);
    },
    anularConfirmacionPresupuesto (item) {
      let params = {
        estado: this.estado,
        item
      }
      this.$emit('anularConfirmacionPresupuesto', params);
    },
    emitirPresupuestoCliente(item) {
      this.$emit('emitirPresupuestoCliente', item);
    },
    emitirPresupuestoInterno(item) {
      this.$emit('emitirPresupuestoInterno', item);
    },
    emitirCertificadoServicio(item) {
      this.$emit('emitirCertificadoServicio', item);
    },
    emitirFacturaProforma(item) {
      this.$emit('emitirFacturaProforma', item);
    },
    exportarExcel(item) {
      this.$emit('exportarExcel', item);
    },
    duplicar(item) {
      this.$emit('duplicarPresupuesto', item);
    },
    cancelar(item) {
      this.$emit('cancelarPresupuesto', item);
    },
    restablecer(item) {
      this.$emit('restablecerPresupuesto', item);
    },
    autorizar(item) {
      this.$emit('autorizarPresupuesto', item);
    },
    cancelarAutorizacion(item) {
      this.$emit('cancelarAutorizacionPresupuesto', item);
    },
    cerrarPresupuesto(item) {
      let params = {
        estado: this.estado,
        item
      }
      this.$emit('cerrarPresupuesto', params);
    },
    abrirPresupuesto(item) {
      let params = {
        estado: this.estado,
        item
      }
      this.$emit('abrirPresupuesto', params);
    },
    agregarPresupuestoAdicional(item) {
      this.$emit('agregarPresupuestoAdicional', item);
    },
    consultarImagenes (item) {
      this.$emit('consultarImagenes', item);
    },
    actualizarCierreEstimadoPresupuesto(item) {
      this.$emit('actualizarCierreEstimadoPresupuesto', item);
    }
  },
  watch: {
    'paginaActualTabla' : function(newVal, oldVal) {
      if (newVal != 0 && oldVal != 0) {
        this.$emit('actualizarPresupuestos', this.paginaActualTabla);
      }
    },    
  }    
}
</script>

<style>
  .presupuestos-internos-list .registro {
    min-height: 300px;
  }
</style>
